import tippy, {followCursor} from 'tippy.js';

export default function initTooltips() {
  const tooltips = document.querySelectorAll('[data-tippy-content]');

  if (tooltips.length == 0) return;

  tooltips.forEach(tooltip => {
    tippy(tooltip, {
      plugins: [followCursor],
      followCursor: true,
      arrow: false,
      maxWidth: 150,
      placement: 'bottom-start',
    });
  })
}